import React from 'react';

const EditFormulaModal = ({
  editingFormula,
  setEditingFormula,
  onSubmit,
}) => {
  if (!editingFormula) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await onSubmit(e, editingFormula);
    } catch (error) {
      console.error('Error updating formula:', error);
    }
  };

  return (
    <div className="modal" id="editFormulaModal" tabIndex="-1">
      <div className="modal-dialog modal-lg">
        <div className="modal-content">
          <form onSubmit={handleSubmit}>
            <div className="modal-header">
              <h5 className="modal-title">Modifier la formule</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
            </div>

            <div className="modal-body">
              {/* Formula Details */}
              <div className="mb-3">
                <label className="form-label">Nom</label>
                <input
                  type="text"
                  className="form-control"
                  value={editingFormula.name || ''}
                  onChange={(e) =>
                    setEditingFormula({ ...editingFormula, name: e.target.value })
                  }
                  required
                />
              </div>

              <div className="row">
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label">Quantité d'articles</label>
                    <input
                      type="number"
                      className="form-control"
                      value={editingFormula.article_quantity || 1}
                      onChange={(e) =>
                        setEditingFormula({
                          ...editingFormula,
                          article_quantity: parseInt(e.target.value),
                        })
                      }
                      required
                      min="1"
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label">Disponibilité</label>
                    <div className="form-check form-switch">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        checked={editingFormula.available}
                        onChange={(e) =>
                          setEditingFormula({
                            ...editingFormula,
                            available: e.target.checked,
                          })
                        }
                      />
                      <label className="form-check-label">
                        {editingFormula.available ? 'Disponible' : 'Indisponible'}
                      </label>
                    </div>
                  </div>
                </div>
              </div>

              {/* Price Table */}
              <div className="mb-3">
                <label className="form-label">Tarifs par durée</label>
                <table className="table table-sm">
                  <thead>
                    <tr>
                      <th>Durée (jours)</th>
                      <th>Prix (€)</th>
                      <th>Caution (€)</th>
                    </tr>
                  </thead>
                  <tbody>
                    {editingFormula.components_pricing_formula_prices?.map((price, index) => (
                      <tr key={index}>
                        <td>
                          <input
                            type="number"
                            className="form-control form-control-sm"
                            value={price.duration_days}
                            onChange={(e) => {
                              const updatedPrices = [...editingFormula.components_pricing_formula_prices];
                              updatedPrices[index].duration_days = parseInt(e.target.value);
                              setEditingFormula({
                                ...editingFormula,
                                components_pricing_formula_prices: updatedPrices,
                              });
                            }}
                            min="1"
                          />
                        </td>
                        <td>
                          <input
                            type="number"
                            className="form-control form-control-sm"
                            value={price.price}
                            onChange={(e) => {
                              const updatedPrices = [...editingFormula.components_pricing_formula_prices];
                              updatedPrices[index].price = parseFloat(e.target.value);
                              setEditingFormula({
                                ...editingFormula,
                                components_pricing_formula_prices: updatedPrices,
                              });
                            }}
                            step="0.01"
                          />
                        </td>
                        <td>
                          <input
                            type="number"
                            className="form-control form-control-sm"
                            value={price.deposit}
                            onChange={(e) => {
                              const updatedPrices = [...editingFormula.components_pricing_formula_prices];
                              updatedPrices[index].deposit = parseFloat(e.target.value);
                              setEditingFormula({
                                ...editingFormula,
                                components_pricing_formula_prices: updatedPrices,
                              });
                            }}
                            step="0.01"
                          />
                        </td>
                        <td>
                          <button
                            type="button"
                            className="btn btn-sm btn-danger"
                            onClick={() => {
                              const updatedPrices = editingFormula.components_pricing_formula_prices.filter(
                                (_, i) => i !== index
                              );
                              setEditingFormula({
                                ...editingFormula,
                                components_pricing_formula_prices: updatedPrices,
                              });
                            }}
                          >
                            X
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                  <tfoot>
                    <tr>
                      <td colSpan="3">
                        <button
                          type="button"
                          className="btn btn-sm btn-secondary"
                          onClick={() => {
                            const currentPrices = editingFormula.components_pricing_formula_prices || [];
                            setEditingFormula({
                              ...editingFormula,
                              components_pricing_formula_prices: [
                                ...currentPrices,
                                { duration: 0, price: 0 },
                              ],
                            });
                          }}
                        >
                          Ajouter un tarif
                        </button>
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>

            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">
                Annuler
              </button>
              <button type="submit" className="btn btn-primary">
                Mettre à jour
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default EditFormulaModal;